import React from 'react';
import {useIntl} from 'react-intl';

import {Button} from '@views/Account/Plan/_components/ActionButtons';
import {useView} from '@views/Account/Plan/_hooks/useView';
import {useNextBoxDate} from '@views/Account/_hooks';
import {ModalOrderCancel} from '@views/Account/Plan/MyPlan/ModalOrderCancel';

type ActionCancelOrderProps = {
  boxId: string;
  onSuccess: () => Promise<void>;
};

const TEXT = {
  BUTTON_CANCEL_ORDER: {id: 'account_yourPlan.planPanel.cancelOrder'},
};

export const ActionCancelOrder: React.FC<ActionCancelOrderProps> = ({boxId, onSuccess}) => {
  const {formatMessage} = useIntl();
  const {visible, open, close} = useView();
  const {raw: boxDate = new Date()} = useNextBoxDate();

  return (
    <>
      <Button onPress={open} testID={'cancel-order-button'}>
        {formatMessage(TEXT.BUTTON_CANCEL_ORDER)}
      </Button>
      <ModalOrderCancel isVisible={visible} onClose={close} onSuccess={onSuccess} date={boxDate} orderId={boxId} />
    </>
  );
};
